export default "__VITE_ASSET__wHNGDNze__"